import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, severity, ...props }) {
        return (
          <Toast
            key={id}
            // HUB-493: data-testid/data-severity let E2E specs target toasts by tier;
            // success toasts announce politely (aria-live polite) while errors and
            // warnings keep Radix's assertive "foreground" announcement.
            data-testid="toast"
            data-severity={severity}
            type={severity === "success" ? "background" : "foreground"}
            {...props}
          >
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
